module.exports = __webpack_public_path__ + "img/object-brain-happy.8b6a324.svg";